var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.198,
    height: 55.198,
    viewBox: "0 0 55.198 55.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M26.753,0h1.692A26.753,26.753,0,0,1,55.2,26.753v1.692A26.753,26.753,0,0,1,28.445,55.2H26.753A26.753,26.753,0,0,1,0,28.445V26.753A26.753,26.753,0,0,1,26.753,0Z",
    fill: "#f7f7f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1537.1-117.038a12.831,12.831,0,0,0,9.085-2.646,6.394,6.394,0,0,1-5.865-4.321,7.385,7.385,0,0,0,2.619-.1l.032-.084a2.952,2.952,0,0,0-.337-.141,5.961,5.961,0,0,1-2.862-1.759A6.214,6.214,0,0,1,1538.12-130c-.017-.3.044-.345.331-.214a6.407,6.407,0,0,0,2.079.569.647.647,0,0,0,.325-.037c-.1-.087-.2-.177-.305-.261a6.184,6.184,0,0,1-2.273-3.725,6.289,6.289,0,0,1,.556-4.044c.116-.237.186-.231.4-.019.7.7,1.354,1.435,2.1,2.074a17.428,17.428,0,0,0,8.514,3.982c.572.1,1.155.141,1.733.2.329.035.4-.037.341-.371a5.288,5.288,0,0,1,.018-2.244,6.127,6.127,0,0,1,4.32-4.78,6.124,6.124,0,0,1,5.817,1.11.315.315,0,0,1,.071.055c.425.6.967.524,1.555.293.941-.37,1.889-.72,2.847-1.084a6.19,6.19,0,0,1-2.391,3.125l.029.072c.354-.058.712-.1,1.062-.177s.719-.183,1.073-.292.7-.237,1.133-.385c-.189.266-.326.476-.479.674a10.89,10.89,0,0,1-2.173,2.162.954.954,0,0,0-.408.872,17.994,17.994,0,0,1-3.366,10.769,16.692,16.692,0,0,1-10.538,6.981,18.083,18.083,0,0,1-10.592-.854c-.891-.356-1.731-.841-2.594-1.269a1.62,1.62,0,0,1-.212-.153Z",
    transform: "translate(-1524.09 155.168)",
    fill: "#259e76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.297382b6.svg";
export { ForwardRef as ReactComponent };